<template>
  <div class="flex items-center justify-end pt-2 text-gray-700">
    <button
      class="size-8 rounded-l-md border border-gray-300 p-1 focus:ring-1 focus:ring-blue-400 focus:outline-none disabled:cursor-not-allowed disabled:text-gray-500"
      :disabled="!hasPrevious || isLoading"
      @click="emit('previous-page')"
    >
      <Icon name="angle-right" class="-mt-1 inline h-5 w-3 rotate-180" />
    </button>
    <div class="flex h-8 items-center gap-1 border-y border-gray-300 text-sm">
      <span
        v-if="isLoading"
        class="mx-4 inline-block size-4 animate-spin rounded-full border-2 border-solid border-gray-500 border-r-transparent"
      ></span>
      <span
        v-else
        class="flex h-5 w-9 items-center justify-center text-center text-sm"
      >
        {{ currentPage }}
      </span>
    </div>
    <button
      class="size-8 rounded-r-md border border-gray-300 p-1 focus:ring-1 focus:ring-blue-400 focus:outline-none disabled:cursor-not-allowed disabled:text-gray-500"
      :disabled="!hasNext || isLoading"
      @click="emit('next-page')"
    >
      <Icon name="angle-right" class="-mt-1 inline h-5 w-3" />
    </button>
  </div>
</template>

<script setup lang="ts">
import Icon from "@/components/Core/Icon.vue";

defineProps({
  currentPage: {
    type: Number,
    required: true,
  },
  hasNext: {
    type: Boolean,
    required: true,
  },
  hasPrevious: {
    type: Boolean,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits({
  "next-page": () => true,
  "previous-page": () => true,
});
</script>
